import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export type CompareNumberOperator = "EQ" | "NE" | "GT" | "GTE" | "LT" | "LTE";

const numberOperatorHumanReadable: Record<CompareNumberOperator, string> = {
  EQ: "Equals (=)",
  NE: "Does not equal (≠)",
  GT: "Greater than (>)",
  GTE: "Greater than or equal (≥)",
  LT: "Less than (<)",
  LTE: "Less than or equal (≤)",
};

interface NumberOperatorSelectorProps {
  operator: CompareNumberOperator | undefined;
  onOperatorChange: (operator: CompareNumberOperator) => void;
  disabled?: boolean;
}

const NumberOperatorSelector = ({
  operator,
  onOperatorChange,
  disabled = false,
}: NumberOperatorSelectorProps) => (
  <Select value={operator || "EQ"} onValueChange={onOperatorChange} disabled={disabled}>
    <SelectTrigger className="w-full">
      <SelectValue placeholder="Select an operator..." />
    </SelectTrigger>
    <SelectContent>
      {(["EQ", "NE", "GT", "GTE", "LT", "LTE"] as const).map(value => (
        <SelectItem key={value} value={value}>
          {numberOperatorHumanReadable[value]}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default NumberOperatorSelector;
